import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../constants';
import Button from './ui/button';
import ContactForm from './forms/ContactForm';

const PuttingPeopleFirstSection = () => {
  return (
    <section className="bg-gray-100 pt-12 sm:pt-16 md:pt-20 pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top heading */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight max-w-4xl mx-auto">
            You can be braver as a business<br />
            <span style={{ color: '#db0058' }}>with the reassurance of insight.</span>
          </h2>
        </div>
        
        {/* Image with overlaid content box */}
        <div className="max-w-6xl mx-auto">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/ppfimg.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Putting<br />
                <span style={{ color: '#db0058' }}>people first.</span>
              </h3>
              
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Tell someone what they want, and chances are they'll ignore you. Ask someone what they want, and the odds
                are they'll tell you. Companies operating a product and service-focused approach constantly tell their
                prospects about products and services. Whereas customer-focused businesses position their products
                and services as precise responses to customer needs.
              </p>
              
              <p className="text-gray-900 font-semibold text-sm mb-6">
                Makes sense, doesn't it?
              </p>
              
              <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/ppfimg.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle right */}
            <div className="absolute top-1/2 right-8 transform -translate-y-1/2 bg-white p-6 sm:p-8 md:p-10 shadow-lg max-w-md">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                Putting<br />
                <span style={{ color: '#db0058' }}>people first.</span>
              </h3>
              
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                Tell someone what they want, and chances are they'll ignore you. Ask someone what they want, and the odds
                are they'll tell you. Companies operating a product and service-focused approach constantly tell their
                prospects about products and services. Whereas customer-focused businesses position their products
                and services as precise responses to customer needs.
              </p>
              
              <p className="text-gray-900 font-semibold text-sm sm:text-base mb-6 sm:mb-8">
                Makes sense, doesn't it?
              </p>
              
              <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Second Image Section with left-positioned text box */}
        <div className="max-w-6xl mx-auto mt-16 sm:mt-20 md:mt-24">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/srfimg.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Setting the<br />
                <span style={{ color: '#db0058' }}>record straight.</span>
              </h3>
              
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Have you been told that consumer data lists are the key to better business outcomes? Or that data management is a complicated and laborious undertaking? Whatever your perception of data is...
              </p>
              
              <p className="text-gray-900 font-semibold text-sm mb-6">
                We're here to build on what you do know and expand on what you don't.
              </p>
              
              <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/srfimg.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle left */}
            <div className="absolute top-1/2 left-8 transform -translate-y-1/2 bg-white p-6 sm:p-8 md:p-10 shadow-lg max-w-md">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                Setting the<br />
                <span style={{ color: '#db0058' }}>record straight.</span>
              </h3>
              
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                Have you been told that consumer data lists are the key to better business outcomes? Or that data management is a complicated and laborious undertaking? Whatever your perception of data is...
              </p>
              
              <p className="text-gray-900 font-semibold text-sm sm:text-base mb-6 sm:mb-8">
                We're here to build on what you do know and expand on what you don't.
              </p>
              
              <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>
        </div>

      </div>
      
      {/* Third Section - Testimonial with split layout - Full width */}
      <div className="w-full mt-16 sm:mt-20 md:mt-24">
        <div className="flex flex-col md:flex-row h-auto md:h-96">
          {/* Left side - Image */}
          <div className="w-full md:w-2/5">
            <img
              src="/images/testmimg.webp"
              alt="Person working in office environment"
              className="w-full h-64 md:h-full object-cover"
            />
          </div>
          
          {/* Right side - Pink background with testimonial */}
          <div className="w-full md:w-3/5 text-white p-8 md:p-12 flex flex-col justify-center relative" style={{ backgroundColor: '#db0058' }}>
            {/* Header section with title and logo */}
            <div className="flex justify-between items-start mb-6">
              {/* Main heading - reduced width */}
              <h3 className="text-xl sm:text-2xl font-bold max-w-[70%] sm:max-w-[75%]">
                Don't just take it from us, here's what our clients have to say...
              </h3>
              
              {/* Logo - aligned with title */}
              <div className="flex-shrink-0 ml-4">
                <img
                  src="/logos/Daco_1493051.png"
                  alt="Company logo"
                  className="h-16 sm:h-20 w-auto filter brightness-0 invert"
                />
              </div>
            </div>
            
            {/* Testimonial text */}
            <p className="text-sm sm:text-base leading-relaxed mb-4">
              High quality data is important. Their product and the insight it brings is invaluable. Combine this with the quality of their people and their approach and that's where it starts to become a true enabler for our business.
            </p>
            
            <p className="text-sm sm:text-base leading-relaxed mb-6">
              They have an in-depth understanding of our business objectives, they ask the right questions and make valid recommendations that I trust. It all results in business growth for us. They refer to themselves as a data consultancy but for us, they're an acquisition and growth provider."
            </p>
            
            {/* Attribution */}
            <p className="text-sm font-semibold uppercase tracking-wide">
              FRANS GERBER, SNR DIGITAL MARKETING MANAGER – A-PLAN INSURANCE
            </p>
          </div>
        </div>
      </div>
      
      {/* Simple Banner Section */}
      <div className="bg-gray-700 py-16 sm:py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
          <div className="text-left">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-white leading-tight">
            We're more than just data,<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>
            <span className="font-bold" style={{ color: '#db0058' }}>we're driven by you.</span>
          </h2>
          </div>
        </div>
      </div>
      
      {/* Let's Talk Section */}
      <div
        className="pt-8 sm:pt-12 lg:pt-16 pb-16 sm:pb-20 lg:pb-24 px-4 sm:px-8 md:px-16 lg:px-24"
        style={{ backgroundColor: COLORS.secondary }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            {/* Left Column - Let's talk */}
            <div className="text-white max-w-md">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-6 sm:mb-8">
                Let's <span style={{ color: '#db0058' }}>talk...</span>
              </h1>
              <div className="space-y-3 sm:space-y-4 text-base sm:text-lg">
                <p>So you're ready to get on board?</p>
                <p>
                  See how Lloyd James could help <strong>unlock the power of your data and take your business further.</strong>
                </p>
              </div>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium" className="mt-6 sm:mt-8">
                  Contact us
                </Button>
              </Link>
            </div>

            {/* Right Column - Enquire now form */}
            <ContactForm
              title="Enquire now"
              webFormId="lloyd_james_putting_people_first_form"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PuttingPeopleFirstSection;